var React = require('react');

function Filtering (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM9.5,13.7l0.9-5.9c0-0.2,0.1-0.3,0.2-0.5L15.2,1H0.8l4.3,6.3c0.1,0.1,0.2,0.3,0.2,0.5l0.1,0.6L6.5,15L9.5,13.7z","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.3","y1":"7.9","x2":"8","y2":"7.9","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"6","y1":"11.9","x2":"8","y2":"11.9","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.9","y1":"3.9","x2":"8","y2":"3.9","key":3})]));
}

Filtering.displayName = "Filtering";

Filtering.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Filtering;

Filtering.default = Filtering;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/filtering.svg
// module id = ../icon/src/icons/filtering.svg
// module chunks = 0